import React, { type ReactNode } from "react";

import Web3Account from "@/components/Web3/Account";
import useWeb3UserAddress from "@/hooks/web3/useWeb3UserAddress";
import Web3CommonAuthenticate from "@/components/Web3/Common/Authenticate";
import UiMessageAtomAnimatedHead from "@/components/Ui/Message/Atom/AnimatedHead";
import { twMerge } from "tailwind-merge";

interface UiMessageRestrictedProps {
  title?: string;
  description?: string;
  children?: ReactNode;
  showConnect?: boolean;
  fullScreen?: boolean;
}

export default function UiMessageRestricted({ title, description, children, showConnect = true, fullScreen = false }: UiMessageRestrictedProps) {
  const address = useWeb3UserAddress();
  return (
    <div className={twMerge("mx-auto flex w-72 max-w-[288px] flex-col justify-center py-16 sm:py-24", fullScreen ? "h-screen" : "h-[500px]")}>
      <UiMessageAtomAnimatedHead />
      {title && (
        <div className="emptystate-card-middle relative lg:opacity-90 lg:hover:opacity-100">
          <div className="h-max w-full p-[24px] text-center text-[48px] font-bold leading-[48px] -tracking-[0.5px]">{title}</div>
        </div>
      )}
      {description && (
        <div className="emptystate-card-middle single-item group relative lg:opacity-90 lg:hover:opacity-100">
          <div className="emptystate-card-message p-[16px] text-center">{description}</div>
        </div>
      )}
      {children}
      {showConnect && (
        <div className="w-full">
          {address ? <Web3CommonAuthenticate className="right-icon emptystate-card-bottom whitespace-nowrap" /> : <Web3Account fullWord className="emptystate-card-bottom" />}
        </div>
      )}
    </div>
  );
}
